// @ts-nocheck
import * as React from "react";
import {inject, observer} from "mobx-react";
import {ExtTaskData} from "../../../../cuba/entities/base/tsadv_ExtTaskData";
import {injectMainStore, MainStoreInjected, Msg} from "@cuba-platform/react";
import {injectIntl, WrappedComponentProps} from "react-intl";
import {TableAdaptive} from "../../../common";
import {getTaskTableColumns} from "./fields";

type TaskProps = {
  tasks: ExtTaskData[];
};

@inject("rootStore")
@injectMainStore
@observer
class TaskDataTable extends React.Component<TaskProps & MainStoreInjected & WrappedComponentProps> {

  render() {
    return (
      <TableAdaptive
        dataSource={this.props.tasks}
        pagination={false}
        key="key"
        bordered
        rowKey="id"
        isNeedMobile
        scroll={{ x: 900 }}
        columns={getTaskTableColumns(this.props.intl, undefined, undefined)}
      />
    )
  }
}

export default injectIntl(TaskDataTable);
